import type { BatchJobItem } from "../../../../lib/corpusApi";

/** One list row: the raw item plus its kind's result narrowed out of the generic `result` bag. A
 *  failed item has none. */
export interface BatchJobItemRow<Result> {
  item: BatchJobItem;
  result: Result | null;
}

/** The id a row is selected and keyed by. */
export function getBatchJobItemRowId(row: BatchJobItemRow<unknown>): string {
  return row.item.id;
}

/** Builds the function that narrows an item's generic result bag to one kind's result: the bag
 *  passes when it carries one of the kind's recognised outcomes, and is null otherwise. */
export function narrowByOutcome<Result extends { outcome: string }>(
  outcomes: ReadonlySet<Result["outcome"]>
): (raw: Record<string, unknown> | null) => Result | null {
  return (raw) => {
    const outcome = raw?.outcome;
    if (typeof outcome !== "string") return null;
    if (!outcomes.has(outcome as Result["outcome"])) return null;
    return raw as unknown as Result;
  };
}
